import type { ReactNode } from 'react';

/**
 * GEN-31/GEN-32 — each list's own worded empty message, with room for the
 * New control beneath it when the page has one.
 */
export function ListEmptyState({ message, action }: { message: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-3 py-10 text-center">
      <p className="text-sm text-muted-foreground">{message}</p>
      {action}
    </div>
  );
}
